/** @jsx jsx */
import { jsx } from '@emotion/react';

type Props = {
  className?: string;
  width?: number;
  height?: number;
};

const GoogleLogoSvg = ({ className, width = 81, height = 83 }: Props) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 81 83"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M80.5373 42.0682C80.5373 39.3597 80.2973 36.7882 79.8859 34.2854H41.1433V49.7482H63.326C62.3317 54.8224 59.4175 59.1081 55.0975 62.0223V72.308H68.3317C76.0802 65.1423 80.5373 54.5824 80.5373 42.0682Z"
      fill="#4285F4"
    />
    <path
      d="M41.1443 82.2858C52.2528 82.2858 61.5442 78.583 68.3327 72.3087L55.0985 62.0231C51.3957 64.4917 46.6986 66.0002 41.1443 66.0002C30.413 66.0002 21.3273 58.766 18.0702 48.9946H4.42458V59.5888C11.1788 73.0287 25.0644 82.2858 41.1443 82.2858Z"
      fill="#34A853"
    />
    <path
      d="M18.0684 48.9942C17.2113 46.5257 16.7656 43.8857 16.7656 41.1428C16.7656 38.4 17.2456 35.76 18.0684 33.2915V22.6973H4.42283C1.61142 28.2515 7.62939e-06 34.4915 7.62939e-06 41.1428C7.62939e-06 47.7942 1.61142 54.0342 4.42283 59.5884L18.0684 48.9942Z"
      fill="#FBBC05"
    />
    <path
      d="M41.1443 16.2856C47.2128 16.2856 52.6299 18.377 56.9156 22.457L68.6413 10.7314C61.5442 4.07997 52.2528 0 41.1443 0C25.0644 0 11.1788 9.25708 4.42458 22.697L18.0702 33.2912C21.3273 23.5198 30.413 16.2856 41.1443 16.2856Z"
      fill="#EA4335"
    />
  </svg>
);

export default GoogleLogoSvg;
